<template>
  <div>
    <el-dialog title="详情" :visible.sync="dialogVisible.show" width="50%" :close-on-click-modal="false">
      <div class="certify-detail">
        <table border="0" cellspacing="0" cellpading="0" width="100%">
          <tr>
            <td class="t_title">用户名：</td>
            <td class="t_text">{{ infoData.username }}</td>
            <td class="t_title">真实姓名：</td>
            <td class="t_text">{{ infoData.realName }}</td>
          </tr>
          <tr>
            <td class="t_title">证件类型：</td>
            <td class="t_text">{{ infoData.idCardType }}</td>
            <td class="t_title">证件号码：</td>
            <td class="t_text">{{ infoData.idCard }}</td>
          </tr>
          <tr>
            <td class="t_title">证件照前面：</td>
            <td class="t_text">
              <el-image style="width: 60px; height: 60px" :src="infoData.idCardFrontUrl" :preview-src-list="[infoData.idCardFrontUrl]">
              </el-image>
            </td>
            <td class="t_title">证件照后面：</td>
            <td class="t_text">
              <el-image style="width: 60px; height: 60px" :src="infoData.idCardBackendUrl" :preview-src-list="[infoData.idCardBackendUrl]">
              </el-image>
            </td>
          </tr>
        </table>
      </div>
      <div class="certify-btn">
        <el-button type="primary" @click="handleCertify(3)">认证通过</el-button>
        <el-button type="danger" @click="handleCertify(4)">认证失败</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { checkUser } from '@/api/certify'
export default {
  props: {
    dialogVisible: {
      type: Object,
      default: function () {
        return {}
      }
    },
  },
  data() {
    return {
      infoData: {}
    }
  },
  watch: {
    dialogVisible: {
      handler(newVal) {
        this.infoData = newVal.detailData
      }
    },
  },
  methods: {

    async handleCertify(val) {
      await checkUser({ id: this.infoData.id, status: val })
      const msg = val == 3 ? '用户认证成功' : '用户认证失败'
      this.$message.success(msg)
      this.dialogVisible.show = false
      this.$emit('getUserList')
    }
  }
}
</script>

<style lang="less" scoped>
.certify-detail {
  table {
    border-collapse: collapse;
  }
  td {
    height: 60px;
    font-size: 14px;
    font-weight: 600;
    background: #fbfcff;
    border: 1px solid #e6e6e6;
  }
  .t_title {
    padding-left: 30px;
    color: #333333;
  }
  .t_text {
    padding-left: 20px;
    color: #2868e8;
  }
}

.certify-btn {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
}
</style>
